import { Formik, Form, Field, ErrorMessage, FieldArray } from 'formik';
import { useRef, useState } from 'react';
import { NavLink, useNavigate } from 'react-router';
import * as Yup from 'yup';
import { API_BASE_URL, API_URL } from '../../utilities/constants';
import { handleApiCall, Label, sleep } from '../../utilities/helper';
import { useUI } from '../../context/UI';
import Button from '../../components/ui/button/Button';
import PaginatedDropdown, { mapOptions } from '../../components/ui/PaginatedDropDown';

const AddVibes = () => {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const fileInputRef = useRef(null);
    const [image, setImage] = useState();
    const [uploadLoading, setUploadLoading] = useState(false);
    const [uploadedURL, setUploadedURL] = useState('');
    const [modules, setModules] = useState(null);
    const [voiceSamples, setVoiceSamples] = useState([]);

    const handleSaveSample = (voiceUrl, toneDescription) => {
        setVoiceSamples((prev) => [
            ...prev,
            { toneDescription, voiceUrl }
        ]);
    };


    const {
        setSegmentTitle,
        addToastMessage,
        addNotification,
        setNewNotification
    } = useUI();
    const initialValues = {
        stylistName: "",
        persona: "",
        lingoStyle: "",
        tips: [""],
        voiceSamples: [
            { toneDescription: "", voiceUrl: "" }
        ],

    };
    const validationSchema = Yup.object().shape({
        stylistName: Yup.string().required('Name is required'),
        persona: Yup.string().required('Persona is required'),
        lingoStyle: Yup.string().required('LingoStyle is required'),

    });

    const handleUpload = async (fileToUpload = image) => {
        // if (!fileToUpload) return; // ✅ No file, exit early
        console.log('fileToUploadfileToUpload', fileToUpload)
        setUploadLoading(true);

        try {
            const formData = new FormData();
            formData.append("file", fileToUpload, fileToUpload.name); //  single file
            formData.append("type", "Stylist");

            const response = await fetch(
                `${API_BASE_URL}/api/1.0.0/files/uploadSystemFile`,
                {
                    method: "POST",
                    headers: {
                        "x-jwt-assertion": localStorage.getItem("token"), //  required header
                    },
                    body: formData,
                }
            );

            const responseData = await response.json();
            console.log("Upload response:", responseData);
            if (response.ok && responseData?.result?.responseCode === 200) {
                const uploadedUrl = responseData.data; //  directly string

                if (uploadedUrl) {
                    setUploadedURL(uploadedUrl);

                    addToastMessage({
                        status: true,
                        message: "Photo uploaded successfully!",
                    });

                    setNewNotification(true);
                    addNotification({
                        id: Date.now(),
                        message: "Photo uploaded successfully!",
                        status: true,
                        archive: false,
                    });
                }
            } else {
                addToastMessage({
                    status: false,
                    message:
                        responseData?.responseDescription ||
                        `Failed to upload ${fileToUpload.name}`,
                });
            }
        } catch (error) {
            console.error("Error uploading Photo:", error);
            addToastMessage({
                status: false,
                message: "Could not upload the photo at the moment.",
            });
            addNotification({
                id: Date.now(),
                message: "Could not upload the photo at the moment.",
                status: false,
                archive: false,
            });
            setNewNotification(true);
        } finally {
            setUploadLoading(false);
        }
    };

    console.log('IMMg', image)
    const handleAddVibes = async (value) => {
        setLoading(true);
        try {
            const payload = {
                stylistName: value.stylistName,
                persona: value.persona,
                lingoStyle: value.lingoStyle,
                isActive: true,
                photoUrl: uploadedURL || "",
                tips: value?.tips?.filter(t => t && t.trim()) || [],
                voiceSamples: voiceSamples.map(v => ({
                    toneDescription: v.toneDescription,
                    voiceUrl: v.voiceUrl.startsWith("blob:") ? "" : v.voiceUrl, // keep only real URLs
                })).filter(v => v.voiceUrl)

                // voiceSamples: voiceSamples.filter(v => v.toneDescription && v.voiceUrl)


            };
            console.log("Payload before API call:", JSON.stringify(payload, null, 2));
            console.log('payload', payload)

            const response = await handleApiCall(API_BASE_URL + "/api/1.0.0/aistylist/stylist", {
                method: "POST",
                body: payload,
            });

            if (response.responseStatus === true) {
                addToastMessage({
                    status: true,
                    message:
                        "You have successfully created a Vibe, Thank You!",
                });
                setNewNotification(true);
                addNotification({
                    id: Date.now(),
                    message: "You have successfully created a Vibe!",
                    status: true,
                    archive: false,
                });
                navigate(`/vibes`);
            }
            else {
                addToastMessage({
                    status: false,
                    message:
                        response?.responseDescription ||
                        "Something went wrong while creating a Vibe. Please try again!",
                });
            }
        } catch (e) {
            setNewNotification(true);
            addNotification({
                id: Date.now(),
                message: "Something went wrong while creating a Stylist.",
                status: false,
                archive: false,
            });
        } finally {
            setLoading(false);
        }
    };

     const labelModuleFunc = (o) => `${o.moduleName}`;

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleAddVibes}
        >
            {({ errors, touched, setFieldValue, values }) => (
                <Form className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-md max- mx-auto space-y-6">

                    <div className=" grid-cols-1 md:grid-cols-2 gap-6">
                        <div>
                            <Label title='Question' />
                            <Field
                                name="stylistName"
                                type="text"
                                placeholder="Enter question"
                                className={`w-full px-3 py-2 border rounded-md text-sm focus:outline-none focus:ring ${errors.country && touched.country
                                    ? "border-red-500 focus:ring-red-300"
                                    : "border-gray-300 focus:ring-brand-300 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-100"
                                    }`}
                            />
                            {errors.stylistName && touched.stylistName && (
                                <p className="text-xs text-red-500 mt-1">{errors.stylistName}</p>
                            )}
                        </div>

                    </div>

                    <div>
                        <Label title='Choices' />
                        <FieldArray name="tips">
                            {({ push, remove }) => (
                                <div className="space-y-2">
                                    {values?.tips.map((tip, index) => (
                                        <div key={index} className="flex items-center gap-2">
                                            <Field
                                                name={`tips.${index}`}
                                                placeholder="Enter a Choice"
                                                className="border rounded px-2 py-1 w-full dark:border-gray-600 dark:bg-gray-800 dark:text-gray-100"
                                                onKeyDown={(e) => {
                                                    if (e.key === "Enter") {
                                                        e.preventDefault();
                                                        push(""); // add new tip field
                                                    }
                                                }}
                                            />
                                            <Button
                                                type="button"
                                                variant="destructive"
                                                onClick={() => remove(index)}
                                                disabled={values.tips.length === 1} // keep at least one
                                            >
                                               <span className='dark:text-gray-200'>Remove</span>
                                            </Button>
                                        </div>
                                    ))}
                                    <Button
                                        type="button"
                                        variant="outline"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            push("");
                                        }}
                                    >
                                        + Add Choices
                                    </Button>
                                </div>
                            )}
                        </FieldArray>
                    </div>
                    <div>
                        <Label title='Events' />
                        <PaginatedDropdown
                            searchkey="search"
                            datakey="records"
                            url={`${API_BASE_URL}/api/1.0.0/modules?`}
                            mapOptions={(records) =>
                                mapOptions(
                                    records,
                                    "moduleId",
                                    labelModuleFunc
                                )
                            }
                            selectedValue={modules}
                            placeHolder='Search'
                            onChange={async (v) => {
                                if (v) {
                                    setModules(v);
                                    const p =
                                        values.modules;
                                    const n = {
                                        val: v.value,
                                        name: v.label,
                                    };
                                    if (
                                        !p.some(
                                            (item) =>
                                                item.val ===
                                                v.value
                                        )
                                    ) {
                                        setFieldValue(
                                            "modules",
                                            [
                                                ...values.modules,
                                                n,
                                            ]
                                        );
                                    }
                                }
                                await sleep();
                                setModules(null);
                            }}
                        />

                        {values?.modules?.length > 0 && (
                            <ul className="w-full py-2">
                                {values?.modules.map((p, j) => (
                                    <li
                                        key={j}
                                        data-tooltip="Click to delete the module."
                                        onClick={() => {
                                            const filtered = values?.modules.filter(
                                                (obj) => obj.val !== p.val
                                            );
                                            setFieldValue("modules", filtered);
                                        }}
                                        className="
                                             inline-block 
                                             mr-1 mb-1 
                                             px-3 py-2 
                                             text-left text-sm 
                                             rounded 
                                             leading-8 
                                             cursor-pointer 
                                             bg-gray-100 text-brand-600 
                                             hover:bg-brand-100 
                                             transition
                                           "
                                        >
                                        <div className="flex items-center justify-start gap-1">
                                            <p className="truncate w-[108px] text-xs">{p.name}</p>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="h-4 w-4"
                                                viewBox="0 0 24 24"
                                            >
                                                <path
                                                    fill="#283f54"
                                                    d="M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm4.151,17.943-4.143-4.1L7.891,18,6.058,16.167l4.1-4.157L6,7.891,7.833,6.058l4.155,4.1L16.094,6l1.849,1.849-4.1,4.141L18,16.094Z"
                                                />
                                            </svg>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                    <div className="flex justify-end gap-3 pt-4">
                        <NavLink to='/vibes'>
                            <button
                                type="reset"
                                className="px-5 py-2 rounded-lg border border-gray-400 text-gray-600 hover:bg-gray-100 dark:border-gray-600 dark:text-gray-300 dark:hover:bg-gray-700 transition"
                            >
                                Cancel
                            </button>
                        </NavLink>
                        <button
                            type="submit"
                            className="px-6 py-2 rounded-lg font-medium bg-brand-600 text-white hover:bg-brand-700 transition"
                        >
                            Submit
                        </button>
                    </div>
                </Form>
            )}
        </Formik>

    );
};

export default AddVibes;


